import { createStore } from 'vuex';

import auth from './auth';
import users from './users';
import labels from './labels';
import settings from './settings';
import serial from './serial';


export default createStore({
  modules: {
    auth,
    users,
    labels,
    settings,
    serial,
  }
});